import React from 'react';

const Fico = () => (
  <svg
    width='60'
    height='61'
    viewBox='0 0 60 61'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M29.5493 27.6654L23.9093 47.1654C22.7093 51.2454 25.7693 55.2654 30.0293 55.2654C34.2293 55.2654 37.2893 51.2454 36.1493 47.1654L30.4493 27.6654C30.3293 27.1854 29.6693 27.1854 29.5493 27.6654Z'
      fill='#97D700'
    />
    <path
      d='M30.0309 51.9054C31.5884 51.9054 32.8509 50.6429 32.8509 49.0854C32.8509 47.528 31.5884 46.2654 30.0309 46.2654C28.4735 46.2654 27.2109 47.528 27.2109 49.0854C27.2109 50.6429 28.4735 51.9054 30.0309 51.9054Z'
      fill='white'
    />
    <path
      d='M18.2345 34.2906L18.2343 34.2932C17.9158 37.7324 19.0285 40.8785 21.095 43.2254H7.89C7.64997 43.2254 7.46815 43.0781 7.41476 42.8823L7.40845 42.8592L7.40103 42.8363C6.65331 40.5357 6.25 38.0599 6.25 35.5254C6.25 21.8215 17.7638 10.8801 31.6465 11.7434C43.1494 12.4918 52.5967 21.7612 53.6338 33.2728C53.923 36.6299 53.574 39.8513 52.6013 42.7692L52.5925 42.7955L52.5852 42.8223C52.5319 43.0181 52.35 43.1654 52.11 43.1654H38.9554C40.7332 41.0976 41.83 38.3767 41.83 35.4654C41.83 28.5159 35.799 22.9464 28.662 23.7313C23.1491 24.3226 18.7594 28.7794 18.2345 34.2906Z'
      fill='#DFF3B2'
      stroke='#06292F'
      stroke-width='2'
    />
  </svg>
);

export default Fico;
